import type { TechFeature } from '../types';

/**
 * 人工编辑调整技术特征服务
 */
export interface FtoReportAdjustTechFeaturesService {
    /**
     * 人工调整技术特征
     */
    adjust(techFeatures: TechFeature[]): Promise<void>;
}

export const FtoReportAdjustTechFeaturesService = Symbol.for('FtoReportAdjustTechFeaturesService');
